import { AUTOCOMPLETE_FIELD_TYPE, DATE_RANGE_FIELD_TYPE, INTEGER_RANGE_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../../../helpers/constants";
import i18n from "../../../../i18n";
import DateService from "../../../../services/dateService";



export const SURVEY_SUMMARY_TABLE_NAME = "answer_registry";

export const SURVEY_SUMMARY_TABLE_FIELDS_CONFIG = [

  {
    name: "evaluator",
    getValueCallback: (rowData) => rowData.evaluator,
    label: i18n.t("table.survey_registry_table.evaluator"),
    filterType: AUTOCOMPLETE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => ({
      options: filteringData?.value?.users,
      isObjectOption: true,
      addNewValue: false,
      multiple: true,
      optionLabelKey: "full_name"
    }),
  },
  {
    name: "questionkind",
    getValueCallback: (rowData) => rowData.questionkind,
    label: i18n.t("table.survey_registry_table.questionkind"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "question",
    getValueCallback: (rowData) => rowData.question,
    label: i18n.t("table.survey_registry_table.question"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "score_count",
    getValueCallback: (rowData) => rowData.score_count,
    label: i18n.t("table.survey_registry_table.score_count"),
    filterType: INTEGER_RANGE_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "hranswer_note",
    getValueCallback: (rowData) => rowData.hranswer_note,
    label: i18n.t("table.survey_registry_table.hranswer_note"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },


];
